module.exports = __webpack_public_path__ + "static/media/xaki-dantela-book-cover.d85efd0a.jpg";